// Settings row: label (and hint) on the left, control on the right.

import type { ComponentChildren } from 'preact';

let nextId = 1;
export const fieldId = (prefix: string) => `${prefix}-${nextId++}`;

export function Field({ label, hint, htmlFor, children, class: cls }: { label: ComponentChildren; hint?: ComponentChildren; htmlFor?: string; children: ComponentChildren; class?: string }) {
  return (
    <div class={`field${cls ? ` ${cls}` : ''}`}>
      <div class="field-text">
        <label class="field-label" for={htmlFor}>
          {label}
        </label>
        {hint && <div class="field-hint">{hint}</div>}
      </div>
      <div class="field-control">{children}</div>
    </div>
  );
}

export function TextInput({ id, value, onChange, placeholder, maxLength, label, onEnter }: { id?: string; value: string; onChange: (v: string) => void; placeholder?: string; maxLength?: number; label?: string; onEnter?: () => void }) {
  return (
    <input
      id={id}
      class="input"
      type="text"
      value={value}
      placeholder={placeholder}
      maxLength={maxLength}
      aria-label={label}
      spellcheck={false}
      onInput={(e) => onChange((e.currentTarget as HTMLInputElement).value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && onEnter) onEnter();
      }}
    />
  );
}
